import ImportedMarkdown from 'markdown-to-jsx';
import { ComponentPropsWithoutRef, Fragment } from 'react';

/**
 * A wrapper component around the markdown component exported from `markdown-to-jsx` library.
 * Example usage
 *
 * ```
 *  <Markdown>
 *    Hello World
 *  </Markdown>
 * ```
 *
 *
 * Since this component expects a single `children` prop of type string, so if your markdown string
 * needs to interpolate variables, you must use it like this
 *
 * ```
 *  const markdownString = `Right now is ${new Date()}`;
 *  <Markdown>
 *    {markdownString}
 *  </Markdown>
 * ```
 *
 *
 * If your markdown string uses the `** **` syntax or anything like that, it's advised to put a `\n`
 * in front of it like so, so that the underlying markdown engine doesn't render weirdly spaced HTML string,
 *
 * ```
 *  const markdownString = `Right now is \n**${new Date()}**`; // Note the `\n` character
 *  <Markdown>
 *    {markdownString}
 *  </Markdown>
 * ```
 *
 * @param props Props to pass to the underlying markdown component library `markdown-to-jsx`
 * @returns
 */
export const Markdown = (props: ComponentPropsWithoutRef<typeof ImportedMarkdown> & { children: string }) => (
  <ImportedMarkdown
    {...props}
    options={{
      ...(props.options || {}),
      wrapper: Fragment
    }}>
    {props.children}
  </ImportedMarkdown>
);
